export default __webpack_public_path__ + "static/media/17.e6f460ae.jpg";